/**
 * useUserSearch Hook (Web)
 * Thin wrapper around shared useUserSearch
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import {
  type UseUserSearchResult,
  useUserSearch as useUserSearchShared,
} from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

// Re-export for existing consumers
export type { SearchResult, UseUserSearchResult } from '@parlay-picker/shared/hooks';

export function useUserSearch(): UseUserSearchResult {
  const { authFetch } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useUserSearchShared({ httpClient });
}
